import type { Database } from '@eqity/shared/database';
import { createClient } from '@supabase/supabase-js';

import { isBrowser } from '~/utils/is-browser.tsx';

function getSupabaseClient(supabaseKey: string, accessToken?: string) {
	const global = accessToken
		? {
				global: {
					headers: {
						Authorization: `Bearer ${accessToken}`,
					},
				},
			}
		: {};

	return createClient<Database>(isBrowser ? window.ENV.SUPABASE_URL : process.env.SUPABASE_URL, supabaseKey, {
		auth: {
			autoRefreshToken: false,
			persistSession: false,
		},
		...global,
	});
}

function getSupabaseAdmin() {
	if (isBrowser) {
		throw new Error('getSupabaseAdmin is not available in browser and should NOT be used in insecure environments');
	}

	return getSupabaseClient(process.env.SUPABASE_SERVICE_ROLE);
}

const supabaseClient = getSupabaseClient(
	isBrowser ? window.ENV.SUPABASE_ANON_PUBLIC : process.env.SUPABASE_ANON_PUBLIC,
);

export { getSupabaseAdmin, supabaseClient };
